import { render, staticRenderFns } from "./maintenance-personnel.vue?vue&type=template&id=2cbd6776&scoped=true"
import script from "./maintenance-personnel.vue?vue&type=script&lang=js"
export * from "./maintenance-personnel.vue?vue&type=script&lang=js"
import style0 from "./maintenance-personnel.vue?vue&type=style&index=0&id=2cbd6776&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbd6776",
  null
  
)

export default component.exports